import { h } from 'preact';

const Spinner = () => (
	<span className="ea-submit-spinner">
		<span>•</span>
		<span>•</span>
		<span>•</span>
	</span>
);

export default Spinner;
